// Module
var code = `<a class="{{ ctrl.className }}" ng-click="ctrl.copyToClipboard()" uib-tooltip="{{ 'COPY_TOOLTIP_TEXT' | translate }}"> {{ 'COPY' | translate }} </a> `;
// Exports
export default code;